<template>
    <div class="mysection">
        <div class="mywxlist">
            <h3>
                <el-button type="default" size="small" >时间<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-button type="default" size="small" >金额<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <div class="list_title_right">共<span class="color_red">300</span>条</div>
            </h3>
            <ul>
                <li>
                   <router-link :to="{path:'wxMyBorrowProjectDetail'}"><h4>普惠个贷项目1：PHGD202188883399</h4></router-link>
                    <el-row class="idata">
                        <el-col :span="8"><span class="color_red">10万</span>金额</el-col>
                        <el-col :span="8"><span>9.8%</span>利率</el-col>
                        <el-col :span="8"><span>180天</span>期限</el-col>
                    </el-row>
                    <el-row class="ml_desc">
                        <el-col :span="24">
                            贷款主体：企业法人，相关证件 <br />
                            还款方式：到期还本付息
                        </el-col>
                    </el-row>
                    <el-row class="statics">
                        <el-col :span="8"><span>担保公司名称</span></el-col>
                        <el-col :span="16">
                            <el-button size="small" type="default" plain>
                                约谈项目
                                <i class="el-icon-arrow-right el-icon--right"></i>
                            </el-button>
                        </el-col>
                    </el-row>
                </li>
                <li>
                    <router-link :to="{path:'wxMyBorrowProjectDetail'}"><h4>普惠个贷项目2：PHGD202188883399</h4></router-link>
                    <el-row class="idata">
                        <el-col :span="8"><span class="color_red">10万</span>金额</el-col>
                        <el-col :span="8"><span>9.8%</span>利率</el-col>
                        <el-col :span="8"><span>180天</span>期限</el-col>
                    </el-row>
                    <el-row class="ml_desc">
                        <el-col :span="24">
                            贷款主体：企业法人，相关证件 <br />
                            还款方式：到期还本付息
                        </el-col>
                    </el-row>
                    <el-row class="statics">
                        <el-col :span="8"><span>担保公司名称</span></el-col>
                        <el-col :span="16">
                            <el-button size="small" type="default" plain>
                                约谈项目
                                <i class="el-icon-arrow-right el-icon--right"></i>
                            </el-button>
                        </el-col>
                    </el-row>
                </li>
                <li>
                    <router-link :to="{path:'wxMyBorrowProjectDetail'}"><h4>普惠个贷项目3：PHGD202188883399</h4></router-link>
                    <el-row class="idata">
                        <el-col :span="8"><span class="color_red">10万</span>金额</el-col>
                        <el-col :span="8"><span>9.8%</span>利率</el-col>
                        <el-col :span="8"><span>180天</span>期限</el-col>
                    </el-row>
                    <el-row class="ml_desc">
                        <el-col :span="24">
                            贷款主体：企业法人，相关证件 <br />
                            还款方式：到期还本付息
                        </el-col>
                    </el-row>
                    <el-row class="statics">
                        <el-col :span="8"><span>担保公司名称</span></el-col>
                        <el-col :span="16">
                            <el-button size="small" type="default" plain>
                                约谈项目
                                <i class="el-icon-arrow-right el-icon--right"></i>
                            </el-button>
                        </el-col>
                    </el-row>
                </li>
            </ul>
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="20">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{

            };
        },
        methods:{
          isWechatBrowser: function () {
            let that=this;
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf('micromessenger') !== -1;
            if (!isWeixin) {
              that.$router.push({name: 'wxError'});
            }
          },
        },
        mounted(){
            this.$store.dispatch('hideHF');
            this.isWechatBrowser();
        },
    }
</script>
<style slot-scope="scope">
    @import '../../assets/css/wxstyle.css';
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxMyBorrowProject.vue